import React from 'react';
import { Button } from '../../Buttons';
import { Body, ErrorFooterStyled, ErrorTemplateStyled, ErrorViewImage, ErrorViewInner, Heading, TextContainer } from './ErrorTemplate.styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function ErrorFooter(_ref) {
  let {
    onClick,
    label,
    children
  } = _ref;
  return label || children ? /*#__PURE__*/_jsxs(ErrorFooterStyled, {
    children: [onClick && /*#__PURE__*/_jsxs(Button, {
      onClick: onClick,
      children: [" ", label, " "]
    }), children]
  }) : null;
}
const levelToIconSize = {
  global: 'medium',
  section: 'medium',
  tile: 'small',
  component: 'small'
};
export function ErrorTemplate(props) {
  const imageAltText = props.imageAltText ? props.imageAltText : 'photo depicting an error';
  const iconSize = props.level ? levelToIconSize[props.level] : 'medium';
  return /*#__PURE__*/_jsx(ErrorTemplateStyled, {
    children: /*#__PURE__*/_jsxs(ErrorViewInner, {
      children: [/*#__PURE__*/_jsx(ErrorViewImage, {
        src: props.image,
        alt: imageAltText,
        size: iconSize
      }), /*#__PURE__*/_jsxs(TextContainer, {
        children: [props.heading && /*#__PURE__*/_jsx(Heading, {
          children: props.heading
        }), /*#__PURE__*/_jsx(Body, {
          children: props.children
        })]
      })]
    })
  });
}